import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import './Image.css';


class Image extends Component {
  render() {
    const styles = {
      container: {
        position: 'relative',
        height: '100%'
      },
      image: {
        background: `url(${this.props.src})`,
        backgroundSize: 'cover',
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0
      }
    };
    return (
      <Grid container direction="row" alignItems="stretch" style={styles.container}>
        <div style={styles.image}></div>
      </Grid>
    );
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image/Image.js